import axios from "axios";
import { baseUrl } from "../config";
const http = axios.create({
  baseURL: baseUrl,
  timeout: 5000
});

http.interceptors.request.use(config => {
  return config;
});
http.interceptors.response.use(res => {
  if (res.status === 200) {
    return res.data || res.datas;
  }
  return { error: true, message: res.message, code: res.code, success: false };
});

export default http;
